export const LOCALE = 'de-DE';
